import React, { useEffect } from "react";
import {
	BrowserRouter as Router,
	Navigate,
	Route,
	Routes,
	useLocation,
} from "react-router-dom";

import LinearProgress from "@mui/material/LinearProgress";

import { routes } from "./routes";

import { PageLayout } from "../components/PageLayout";

import Home from "../pages/Home";

import { useConfig } from "../context/ConfigContext";
import Admin from "../pages/Admin";
import { AdminPanelProvider } from "../context/AdminPanelContext";
import { useClientAccessContext } from "../context/ClientAccessContext";
import SelectClient from "../pages/SelectClient";
import SelectTopic from "../pages/SelectTopic";
import { UserRole } from "../context/ConfigContext/types";
import { GlobalUserRole } from "../context/ClientAccessContext/types";
import PowerBiReport from "../pages/PowerBiReport";

export const clientsWithReport = [2, 4];

export default function AuthenticatedRoutes(): JSX.Element {
	const { selectedClient, userWithClients } = useClientAccessContext();
	const { loadingCategories, loadingTopics, selectedTopic, user, queryParams } =
		useConfig();

	const getIndex = () => {
		if (!selectedClient) return <Navigate to={routes.selectClient} />;
		if (!selectedTopic) return <Navigate to={routes.selectTopic} />;
		return loadingCategories ? <LinearProgress /> : <Home />;
	};

	const handleReportRoute = () => {
		if (
			!user ||
			!clientsWithReport.includes(user.clientId) ||
			!selectedClient ||
			!clientsWithReport.includes(selectedClient.clientId)
		) {
			return <Navigate to={routes.overview} replace />;
		}
		return <PowerBiReport />;
	};

	const handleAdminRoute = () => {
		if (
			(!loadingTopics &&
				(!user || user?.role !== UserRole.ADMIN) &&
				(!userWithClients ||
					userWithClients?.globalRole !== GlobalUserRole.ADMIN)) ||
			!selectedClient ||
			!selectedTopic
		)
			return <Navigate to={routes.index} />;
		return (
			<AdminPanelProvider>
				<Admin />
			</AdminPanelProvider>
		);
	};

	return (
		<Router>
			<QueryParamSync />
			<Routes>
				<Route element={<PageLayout />}>
					<Route path={routes.index} element={getIndex()} />
					<Route path={routes.overview} element={getIndex()} />
					<Route path={routes.admin} element={handleAdminRoute()} />
					<Route path={routes.selectClient} element={<SelectClient />} />
					<Route path={routes.selectTopic} element={<SelectTopic />} />
					<Route path={routes.report} element={handleReportRoute()} />
					<Route path="*" element={<Navigate to={routes.index} />} />
				</Route>
			</Routes>
		</Router>
	);
}

export function QueryParamSync() {
	const { search } = useLocation();
	const { setQueryParams } = useConfig();

	useEffect(() => {
		console.log(Object.fromEntries(new URLSearchParams(search)));
		if (!search) return;
		setQueryParams(Object.fromEntries(new URLSearchParams(search)));
	}, [search, setQueryParams]);

	return null;
}
